import PropTypes from 'prop-types';

export const themeShape = PropTypes.shape({
  color: PropTypes.shape({
    overlayDarkHeavy: PropTypes.string,
    overlayDarkFaint: PropTypes.string,
    playerBackground: PropTypes.string,
    page: PropTypes.string,
    primary: PropTypes.string,
    brand: PropTypes.string,
    light: PropTypes.string,
    buttonColor: PropTypes.string,
    buttonColorHover: PropTypes.string,
    buttonBackground: PropTypes.string,
    secondaryButtonBackground: PropTypes.string,
    secondaryButtonBackgroundHover: PropTypes.string,
    playerProgressTrack: PropTypes.string,
    progressBarFillColor: PropTypes.string,
    progressBarFillColorLive: PropTypes.string,
    availableBarFillColor: PropTypes.string,
    thumbBackgroundColor: PropTypes.string,
    controlsMenuBgColor: PropTypes.string,
    bufferedBarFillColor: PropTypes.string,
    ads: PropTypes.string,
    adInfoBgColor: PropTypes.string,
    ratingTextColor: PropTypes.string,
    ratingBgColor: PropTypes.string,
  }),
  radius: PropTypes.shape({
    default: PropTypes.string,
    small: PropTypes.string,
  }),
  fontSize: PropTypes.shape({
    loud: PropTypes.string,
    pageHeading: PropTypes.string,
    sectionHeading: PropTypes.string,
    medium: PropTypes.string,
    normal: PropTypes.string,
    small: PropTypes.string,
    fine: PropTypes.string,
  }),
  margin: PropTypes.shape({
    xxlarge: PropTypes.string,
    xlarge: PropTypes.string,
    large: PropTypes.string,
    medium: PropTypes.string,
    small: PropTypes.string,
    fine: PropTypes.string,
  }),
  opacity: PropTypes.shape({
    disabled: PropTypes.number,
    enabled: PropTypes.number,
    hovered: PropTypes.number,
  }),
  transition: PropTypes.shape({
    default: PropTypes.string,
  }),
  iconHeight: PropTypes.shape({
    large: PropTypes.string,
    medium: PropTypes.string,
    small: PropTypes.string,
  }),
});

/*
 * Theme for styling the controls
 * Will be overwritten by options.theme
 */
export const defaultTheme = {
  color: {
    overlayDarkHeavy: 'rgba(6, 0, 6, .78)',
    overlayDarkFaint: 'rgba(6, 0, 6, .28)',
    playerBackground: 'rgb(0, 0, 0)',
    page: 'rgba(31, 35, 38, 1)',
    primary: 'rgba(255, 255, 255, 1)',
    primaryHover: 'rgba(230, 230, 230, 1)',
    brand: 'rgba(255, 98, 51, 1)',
    light: 'rgba(255, 255, 255, 1)',
    buttonColor: 'rgba(255, 255, 255, 1)',
    buttonColorHover: 'rgba(230, 230, 230, 1)',
    buttonBackground: 'rgba(255, 255, 255, 0.3)',
    secondaryButtonBackground: 'rgba(128, 128, 128, 0.5)',
    secondaryButtonBackgroundHover: 'rgba(128, 128, 128, 0.8)',
    playerProgressTrack: 'rgba(255, 255, 255, 0.3)',
    progressBarFillColor: 'rgba(255, 98, 51, 1)', // brand
    progressBarFillColorLive: 'rgba(232, 12, 11, 1)',
    availableBarFillColor: 'rgba(255, 255, 255, 1)',
    thumbBackgroundColor: 'rgba(210, 210, 210,  1)',
    controlsMenuBgColor: 'rgba(37, 37, 37, 1)',
    bufferedBarFillColor: 'rgba(31, 35, 38, 0.7)', // lightSecondary
    ads: 'rgb(248, 231, 28)',
    adInfoBgColor: 'rgba(37, 37, 37, 0.6)',
    ratingTextColor: 'rgba(255, 255, 255, 1)',
    ratingBgColor: 'rgba(128, 128, 128, 0.8)',
  },
  radius: {
    default: '4px',
    small: '2px',
  },
  fontSize: {
    loud: '40px',
    pageHeading: '32px',
    sectionHeading: '28px',
    medium: '20px',
    normal: '16px',
    small: '14px',
    fine: '12px',
  },
  margin: {
    xxlarge: '56px',
    xlarge: '40px',
    large: '24px',
    medium: '16px',
    small: '12px',
    fine: '8px',
  },
  opacity: {
    disabled: 0.3,
    enabled: 0.7,
    hovered: 1,
  },
  transition: {
    default: '200ms ease-in-out',
  },
  iconHeight: {
    large: '32px',
    medium: '28px',
    small: '21px',
  },
};
